import React, { useState, useMemo, createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { AppTheme } from "./theme/AppTheme";

export const ThemeContext = createContext({
  mode: "dark",
  toggleTheme: () => { },
});

function Root() {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("rmcs-theme") || "dark";
  });

  const toggleTheme = () => {
    setMode((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem("rmcs-theme", next);
      return next;
    });
  };

  const theme = useMemo(() => AppTheme(mode), [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
